<template>
  <v-data-table
    :headers="headers"
    :items="perguntasEvidenciadas"
    class="elevation-1"
    hide-default-footer
    disable-pagination
    :expanded.sync="expanded"
    single-expand
    item-key="perguntaMunicipioId"
  >
    <template v-slot:item="props">
      <tr class="evidenciada">
        <td
          @click="removeQuestion(props.item)"
          style="cursor: pointer"
          title="DESCARTAR QUESTÃO E EVIDÊNCIAS"
        >
          <img style="width: 30px" src="/assets/img/removeQuestion.png" />
        </td>
        <td>{{ props.item.nome }}</td>
        <td>{{ props.item.numero }}</td>
        <td @click="openEvidence(props.item)" v-if="props.item.temArquivo">
          <div class="optionsExpanded">
            <div style="width: 80%">{{ props.item.texto }}</div>
            <div
              :class="`openExpanded ${
                expanded.length > 0 &&
                props.item.perguntaMunicipioId ===
                  expanded[0].perguntaMunicipioId
                  ? 'expandedClass'
                  : ''
              }`"
              v-if="
                isFullAdmin ||
                (groupsConfig.visualizarEvidenciadas &&
                  config.visualizarEvidenciadas)
              "
            ></div>
          </div>
        </td>
        <td v-else></td>
        <td>{{ props.item.pontos }}</td>
        <td width="300px">
          <v-file-input
            v-if="
              isFullAdmin ||
              (groupsConfig.enviarEvidenciadas && config.enviarEvidenciadas)
            "
            multiple
            label="Selecione Arquivos de Evidência"
            v-model="props.item.arquivos"
          >
          </v-file-input>
        </td>
        <td>
          <v-btn
            v-if="
              isFullAdmin ||
              (groupsConfig.enviarEvidenciadas && config.enviarEvidenciadas)
            "
            outlined
            color="primary"
            class="ml-3"
            @click="sendEvidences(props.item)"
          >
            <span>Enviar</span>
          </v-btn>
        </td>
        <td v-if="props.item.evidencia">
          <app-modal-show-evidence
            :evidence="props.item.evidencia"
            :color="'primary'"
          >
          </app-modal-show-evidence>
        </td>
        <td v-else></td>
      </tr>
    </template>
    <template v-slot:expanded-item="props">
      <tr
        v-if="
          isFullAdmin ||
          (groupsConfig.visualizarEvidenciadas && config.visualizarEvidenciadas)
        "
      >
        <td colspan="9" class="p-0">
          <app-get-evidence-question
            :perguntaId="props.item.perguntaMunicipioId"
            @updateValue="updateValue"
            :evidences="evidences"
            :type="'Evidenciadas'"
          ></app-get-evidence-question>
        </td>
      </tr>
    </template>
    <template slot="no-data">
      <span> Nenhuma pergunta retornada </span>
    </template>
  </v-data-table>
</template>

<script>
import { cityQuestionAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import AppGetEvidenceQuestion from "@/modules/evidence/components/GetQuestion";
import AppModalShowEvidence from "@/modules/diagnostic/components//ModalShowEvidence";
import { sortArrayAsc } from "../../../../helpers/utils";

import Swal from "sweetalert2";

export default {
  components: {
    AppGetEvidenceQuestion,
    AppModalShowEvidence,
  },
  data() {
    return {
      headers: [
        { text: "", value: "removeEvidence" },
        { text: "Tema", value: "pergunta.tema.nome" },
        { text: "Número", value: "pergunta.numero" },
        { text: "Texto", value: "pergunta.texto" },
        { text: "Pontos", value: "pergunta.pontos" },
        { text: "", value: "enviar" },
        { text: "", value: "acao" },
        { text: "Evidência", value: "evidencia" },
      ],
      municipioId: this.$route.params.id,
      perguntasEvidenciadas: [],
      expanded: [],
      allPerguntas: [],
      evidences: [],
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      user: JSON.parse(localStorage.getItem("user")),
    };
  },
  props: {
    filter: { type: Object, default: () => ({}) },
  },
  watch: {
    filter: {
      handler(val, oldVal) {
        if (val.temas.length)
          this.perguntasEvidenciadas = this.allPerguntas.filter((pa) =>
            val.temas.some((te) => te.nome === pa.nome)
          );
        else this.perguntasEvidenciadas = this.allPerguntas;
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "setLoading",
      "setConsultorCondutorMunicipio",
      "setConsultorEspecialistaMunicipio",
      "setAnalistaMunicipio",
      "setADMunicipio",
    ]),
    removeQuestion(pergunta) {
      Swal.fire({
        title: "Atenção!",
        text: `Deseja realmente DESCARTAR esta questão e todas as suas evidências para retorno da mesma à 
             situação de RESPONDIDAS? Desta forma, no próximo acompanhamento a questão aparecerá novamente e o 
             município perderá os pontos correspondentes`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
      }).then((result) => {
        if (result.isConfirmed) {
          this.setLoading(true);
          cityQuestionAPI
            .atualizarPergunta(pergunta.perguntaMunicipioId)
            .then(() => {
              this.loadHighlightedQuestions();
            })
            .catch(() => {
              this.setLoading(false);
              this.$notification.error("Erro ao salvar remover questão");
            });
        }
      });
    },
    openEvidence(evidenceSlot) {
      if (this.expanded.length > 0) {
        this.expanded.forEach((item, index) => {
          if (item === evidenceSlot) {
            this.expanded.splice(index, 1);
          } else {
            this.expanded = [];
            this.expanded.push(evidenceSlot);
          }
        });
      } else {
        this.expanded.push(evidenceSlot);
      }
      if (this.expanded[0]) {
        this.setLoading(true);
        cityQuestionAPI
          .getPergunta(this.expanded[0].perguntaMunicipioId)
          .then((resp) => {
            this.evidences = resp.data.evidencias;
            this.setLoading(false);
          })
          .catch((err) => {
            console.log("err: ", err);
            this.setLoading(false);
            this.$notification.error("Erro ao obter pergunta");
          });
      }
    },
    sendEvidences(question) {
      if (question.arquivos.length === 0) {
        this.$notification.error("Não há evidências a serem enviadas!");
      } else {
        this.setLoading(true);

        let formData = new FormData();

        for (let i = 0; i < question.arquivos.length; i++) {
          formData.append("arquivos", question.arquivos[i]);
        }

        formData.append("perguntaMunicipioId", question.perguntaMunicipioId);

        cityQuestionAPI
          .salvarEvidencias(formData)
          .then((resp) => {
            this.$notification.success("Evidência salva com sucesso");
            this.loadHighlightedQuestions();
            this.expanded = [];
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao salvar evidência");
          });
      }
    },
    loadHighlightedQuestions() {
      this.setLoading(true);
      cityQuestionAPI
        .getEvidenciadas(this.municipioId)
        .then((resp) => {
          this.perguntasEvidenciadas = resp.data.sort((a, b) => {
            return (
              sortArrayAsc(a.temaId, b.temaId) ||
              sortArrayAsc(a.numero, b.numero)
            );
          });

          if (!this.user.grupo.verTodosEixos) {
            this.perguntasEvidenciadas = this.perguntasEvidenciadas.filter(
              (item) =>
                this.user.permissoes.some(
                  (per) =>
                    per.eixoId === item.eixoId &&
                    per.municipioId === item.municipioId
                )
            );
          }
          this.allPerguntas = this.perguntasEvidenciadas;

          if (this.filter.temas.length > 0) {
            this.perguntasEvidenciadas = this.allPerguntas.filter((pa) =>
              this.filter.temas.some((te) => te.nome === pa.nome)
            );
          }

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter perguntas");
        });
    },
    updateValue() {
      this.loadHighlightedQuestions();
    },
  },

  mounted() {
    this.loadHighlightedQuestions();
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "uf",
      "logo",
      "isAnalista",
      "isFullAdmin",
    ]),
  },
};
</script>

<style lang="scss">
a {
  text-decoration: none;
}
.p-0 {
  padding: 0 !important;
}
.hasEvidence {
  background: url("/assets/img/certo1.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
  margin: 0 auto;
}
.hasNoEvidence {
  background: url("/assets/img/noEvidence.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
  margin: 0 auto;
}
.semStatus {
  background: url("/assets/img/search.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
  margin: 0 auto;
}

.optionsExpanded {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.openExpanded {
  background: url("/assets/img/right-arrow.png") no-repeat;
  width: 20px;
  height: 20px;
  transform: rotate(90deg);
  display: block;
  background-size: contain;
  /* text-align: center; */
  margin: 0 auto;
  float: right;
}
.expandedClass {
  transform: rotate(270deg);
}
</style>
